if (!customElements.get("media-gallery-bb")) {
  customElements.define(
    "media-gallery-bb",
    class MediaGalleryBB extends HTMLElement {
      constructor() {
        super();

        this.thumbnails = null;
        this.main = null;
        this.initialSplide = this.initialSplide.bind(this); // Bind `this`
        this.splideInitialized = false;

        this.pdpMainHeight = 500; // set height default
        this.videoWrapper = document.querySelector("#main-carousel .video-wrapper");
        this.video = document.querySelector("#main-carousel .splide-video");
        this.playButton = document.querySelector("#main-carousel .splide__slide .play-icon");
      }

      connectedCallback() {
        window.addEventListener("DOMContentLoaded", () => {
          this.initialSplide();
          this.setInitialThumbHeight();
        });
        window.addEventListener("resize", () => {
          this.setInitialThumbHeight();
        });

        if (this.videoWrapper) {
          this.videoWrapper.addEventListener("click", () => this.playPauseVideo());
        }

        if (window.innerWidth > 750 && this.video !== null) {
          this.video.click();
        }
      }

      initialSplide() {
        if (this.splideInitialized) {
          this.thumbnails.destroy();
          this.main.destroy();
          this.splideInitialized = false;
        }

        const thumbnailSettings = {
          gap: 10,
          width: "100%",
          height: this.pdpMainHeight,
          isNavigation: true,
          pagination: false,
          arrows: true,
          lazyLoad: false,
          rewind: true,
          rewindSpeed: 2000,
        };

        const mainSettings = {
          type: "loop",
          arrows: true,
          perMove: 1,
          focus: 0,
          lazyLoad: false,
        };

        if (window.innerWidth >= 1280) {
          mainSettings.perPage = 2;
          mainSettings.height = this.pdpMainHeight;
          thumbnailSettings.direction = "ttb";
          mainSettings.width = "100%";
        } else if (window.innerWidth >= 1024 && window.innerWidth < 1280) {
          mainSettings.perPage = 1;
          mainSettings.height = this.pdpMainHeight;
          thumbnailSettings.direction = "ttb";
          mainSettings.width = "100%";
        } else if (window.innerWidth >= 750 && window.innerWidth < 1024) {
          mainSettings.perPage = 2;
          mainSettings.arrows = false;
          mainSettings.height = "100%";
          thumbnailSettings.direction = "ltr";
          thumbnailSettings.perPage = 5;
        } else {
          mainSettings.perPage = 1;
          mainSettings.arrows = false;
          mainSettings.height = "100%";
          thumbnailSettings.direction = "ltr";
          thumbnailSettings.perPage = 4;
        }

        this.thumbnails = new Splide("#thumbnail-carousel", thumbnailSettings).mount();
        this.main = new Splide("#main-carousel", mainSettings).mount();

        if (this.main && this.thumbnails) {
          this.main.sync(this.thumbnails);
          this.splideInitialized = true;
        }

        this.enableZoomOnImages();
      }

      setInitialThumbHeight() {
        const mainCarousel = document.querySelector(".pdp-main-carousel");
        if (mainCarousel) {
          const newHeight = mainCarousel.offsetHeight || 500;

          if (newHeight !== this.pdpMainHeight) {
            this.pdpMainHeight = newHeight;
            this.initialSplide();
          }
        }
      }

      enableZoomOnImages() {
        const zoomElements = document.querySelectorAll(".pdp-image-zoom");
        zoomElements.forEach((element) => {
          const image = element.querySelector(".pdp-image-desktop");
          const scaleValue = element.getAttribute("data-scale");

          if (window.innerWidth > 1024) {
            element.addEventListener("mouseover", () => {
              image.style.transform = `scale(${scaleValue})`;
            });
            element.addEventListener("mouseout", () => {
              image.style.transform = "scale(1)";
            });
            element.addEventListener("mousemove", (event) => {
              const offsetX = event.pageX - element.getBoundingClientRect().left;
              const offsetY = event.pageY - element.getBoundingClientRect().top;
              const xPercent = Math.min(Math.max((offsetX / element.offsetWidth) * 100, 0), 100);
              const yPercent = Math.min(Math.max((offsetY / element.offsetHeight) * 100, 0), 100);
              image.style.transformOrigin = `${xPercent}% ${yPercent}%`;
            });
          } else {
            element.addEventListener("mouseover", () => {
              image.style.transform = "none";
            });
            element.addEventListener("mouseout", () => {
              image.style.transform = "none";
            });
          }
        });
      }

      playPauseVideo() {
        if (this.video.paused) {
          this.playButton.classList.add("splide-hide-icon");
          this.video.play();
        } else {
          this.playButton.classList.remove("splide-hide-icon");
          this.video.pause();
        }
      }
    }
  );
}